<template>
  <div class="card-details">
    <i class="icon-card" :class="iconClass" />
    <translate v-if="brand === 'ideal'" class="details">
      Paid with iDEAL
    </translate>
    <translate v-else-if="brand === 'pay_by_bank'" class="details">
      Paid with Pay by Bank
    </translate>
    <span v-else-if="isCardPayment" class="details">
      {{ $t('Expiry') }} {{ card.expMonth }}/{{ card.expYear }}
      <translate class="last4" :tt="{ last4: card.last4 }"
        >(ending in {last4})</translate
      >
    </span>
    <span v-else class="details"> {{ $t('Paid with') }} {{ brand }} </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { PaymentCard as Card } from '../../../payments/types'

@Component
class PaymentCard extends Vue {
  @Prop()
  card: Card

  // Known card brands that should show expiry/last4 format
  private readonly cardBrands = [
    'visa',
    'mastercard',
    'amex',
    'american express',
    'discover',
    'diners',
    'jcb',
    'unionpay',
    'maestro',
  ]

  get brand() {
    return this.card.brand.toLowerCase()
  }

  get isCardPayment() {
    return (
      this.cardBrands.includes(this.brand) ||
      (this.card.expMonth && this.card.expYear && this.card.last4)
    )
  }

  get iconClass() {
    // Map payment method types to CSS classes
    if (this.brand === 'pay_by_bank') {
      return 'bank'
    }
    return this.brand
  }
}

export default toNative(PaymentCard)
</script>

<style scoped>
@import url('~/assets/css/payment-cards.css');

.card-details {
  align-items: center;
  display: flex;
  margin: 0.5em 0;
}

.icon-card {
  background-position: center center;
  background-repeat: no-repeat;
  display: inline-block;
  height: 1.7em;
  margin-right: 0.5em;
  position: relative;
  width: 2.7em;
}

.icon-card.ideal {
  margin-right: 0;
}
</style>
